import { BaseEvent } from '../../../../../domain/event/base-event';
export class AssetEvent extends BaseEvent {
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        metadata = {
            aggregatename: 'Asset',
            ...metadata,
        };
        super({
            subject,
            type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
//# sourceMappingURL=asset.event.js.map